export default {
    SET_BANK_CODE: (state, bankCode) => { state.bankCode = bankCode; },
};
